import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { useReactToPrint } from 'react-to-print';


// Components
import MainCard from '../../../components/MainCard/MainCard';
import NovoEnviarResiduo from './NovoEnviarResiduo';
import Loading from '../../../components/Loading/Loading';

//API
import redestinacao_api from '../../../api/redestinacao_api';

//Helpers
import { showMessage } from 'helpers/message';


import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';
import moment from 'moment';


function FichaEnviarResiduos({ btnVoltar, id }) {
    //Estado de controle dos dados do redestinação 
    const [redestinacao, setRedestinacao] = useState(null);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle de edição do gerador
    const [novo, setNovo] = useState(false);

    //referencia do relatorio
    const refRelatorio = useRef();

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Redestinação",
    });

    const headersRedestinacao = [
        { value: "Modalidade", objectValue: "modalidade" },
        { value: "Peso Destinado", objectValue: "pesoDestinado" }
    ];


    const loadRedestinacao = (id) => {
        setLoading(true);
        redestinacao_api.GetItem(id).then(response => {
            response.data.redestinacaoDestino.id = response.data?.redestinacaoDestino?.id ? response.data.redestinacaoDestino?.id.toString() : "";
            response.data.tbTransportadores_Id = response.data?.tbTransportadores_Id ? response.data.tbTransportadores_Id.toString() : "";
            response.data.tbVeiculos_Id = response.data?.tbVeiculos_Id ? response.data?.tbVeiculos_Id?.toString() : "";
            response.data.dataRegistro = moment(response.data.dataRegistro).format("DD/MM/YYYY");
            response.data.dataColeta = response.data.dataColeta ?  moment(response.data.dataColeta).format("DD/MM/YYYY HH:mm") : "";
            response.data.redestinacaoTipoColetas =  response.data.redestinacaoTipoColetas?.map(value => {
                value.pesoDestinado = value.pesoDestinado.toFixed(2).replace(".", ",")
                return value;
            });
            setRedestinacao(response.data)
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    useEffect(() => {
        loadRedestinacao(id);
    }, []);

    if (novo) {
        return <NovoEnviarResiduo
            btnVoltar={() => {
                setNovo(null)
                btnVoltar()
            }}
            redestinacaoItem={redestinacao}
        />
    }

    return <MainCard
        btnVoltarInTop={btnVoltar}
        btnImprimir={handlePrint}
        btnEditarInTop={redestinacao && redestinacao.status == "Coletado" ? null : () => setNovo(true)}
    >
        {loading && <Loading />}
        <div style={{ color: "#666" }} className="mt-4 relatorio w-100" ref={refRelatorio}>
            <div className='m-2 body'>
                <h5
                    className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center'
                    style={{ color: "#fff" }}
                >
                    <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Origem</span>
                </h5>
                <div className='row mb-2'>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Destino Origem: </span> {redestinacao?.destinoOrigem}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Transportador: </span> {redestinacao?.transportadorFantasia}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Veiculo: </span> {redestinacao?.placaVeiculo}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Data/Hora Registro: </span> {redestinacao?.dataRegistro}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Data/Hora Coleta: </span> {redestinacao?.dataColeta}</p>
                    </div>
                </div>

                <h5
                    className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center'
                    style={{ color: "#fff" }}
                >
                    <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Destino</span>
                </h5>
                <div className='row mb-2'>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Destino Envio: </span> {redestinacao?.redestinacaoDestino?.destinoFantasia}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Data/Hora: </span>  {redestinacao?.dataColeta}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Peso Entrada: </span> {redestinacao?.redestinacaoDestino?.pesoEntrada}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Peso Saida: </span> {redestinacao?.redestinacaoDestino?.pesoSaida}</p>
                    </div>
                </div>

                <h5
                    className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center'
                    style={{ color: "#fff" }}
                >
                    <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Modalidades de Coleta</span>
                </h5>
                <div className="row">
                    <div className='col-md-12 col-lg-12 w-100 '>
                        <TabelaListagemFichas headers={headersRedestinacao} items={redestinacao?.redestinacaoTipoColetas} width={"100%"} />
                    </div>
                </div>
            </div>
        </div>
    </MainCard>;
}

export default FichaEnviarResiduos;